
import React from 'react';

const StillHaveQuestionsSection: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-green-50 rounded-lg p-12 text-center">
          <div className="max-w-3xl mx-auto">
            <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-customer-service-2-line text-white text-2xl"></i>
            </div>
            
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Still Have Questions?
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Can't find what you're looking for? Our training consultants are here to help 
              with personalized answers to your specific questions.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
              <div className="text-center">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Call Us</h3>
                <p className="text-gray-600">+27 10 224 0406</p>
                <p className="text-sm text-gray-500">Mon-Fri: 08:30-16:30</p>
              </div>

              <div className="text-center">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Email Us</h3>
                <p className="text-gray-600">info@sylman.co.za</p>
                <p className="text-sm text-gray-500">Response within 24 hours</p>
              </div>

              <div className="text-center">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-calendar-line text-white text-xl"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Schedule a Call</h3>
                <p className="text-gray-600">Free consultation</p>
                <p className="text-sm text-gray-500">Expert training advice</p>
              </div>
            </div>

            <div className="space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">
              <a
                href="/contact"
                className="inline-block bg-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors whitespace-nowrap"
              >
                Contact Us
              </a>
              <button className="inline-block bg-white text-green-600 border-2 border-green-600 px-8 py-3 rounded-lg font-semibold hover:bg-green-50 transition-colors whitespace-nowrap">
                Request Callback
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StillHaveQuestionsSection;
